import React from 'react';
import { Tooltip } from 'react-tooltip';

import { ReactComponent as DownloadIcon } from '@assets/svg/header-download-icon.svg';

import style from './style.module.scss';

const BtnHeaderDownload = ({ tooltipInfo, downloadFn }) => (
  <>
    <DownloadIcon id="header-upload-icon" className={style.uploadIcon} onClick={downloadFn} />
    {tooltipInfo && <Tooltip anchorSelect="#header-upload-icon" content={tooltipInfo} />}
  </>
);

export default BtnHeaderDownload;
